import axiosSetup from "../utils/axiosSetup";
import toast from "react-hot-toast";

export const handleAddStatusColumn = async (columnTitle: string) => {
  try {
    const response = await axiosSetup.post("/leads/addStatus", {
      title: columnTitle,
    });
    return response.data.data;
  } catch (error) {
    toast.error("Failed to add status column");
    throw new Error("Failed to add status column");
  }
};

export const handleDeleteStatusColumn = async (columnId: string) => {
  try {
    const response = await axiosSetup.delete("/leads/deleteStatus", {
      data: { id: columnId },
    });
    return response.data;
  } catch (error) {
    toast.error("Failed to delete status column");
    throw new Error("Failed to delete status column");
  }
};
